import { Button, IconButton, Tooltip } from "@mui/material";

import { ArrowUpwardOutlined } from "@mui/icons-material";
import PulsatingStopCircle from "./PulsatingStopCircle";

type ChatInputAdorementsProps = {
  isInputting: boolean;
  isChatLoading: boolean;
  isGenerating: boolean;
  handleFormSubmit: (event: React.FormEvent | React.KeyboardEvent) => void;
  onStopChat: () => void;
  /** Override the default `aa-input-stop-btn` testid (e.g. for product-namespaced QA selectors). */
  stopBtnTestId?: string;
};

const ChatInputAdorements = ({
  isInputting,
  isChatLoading,
  isGenerating,
  handleFormSubmit,
  onStopChat,
  stopBtnTestId,
}: ChatInputAdorementsProps) => {
  return (
    <>
      {!isGenerating && !isChatLoading && (
        <Tooltip title="Submit">
          <span style={{ marginLeft: "auto" }}>
            <Button
              disableElevation
              disabled={!isInputting}
              color="primary"
              variant="contained"
              startIcon={<ArrowUpwardOutlined />}
              data-testid="aa-input-send-btn"
              data-attr="assistant:btn:send-message"
              sx={{
                "& .MuiButton-startIcon": {
                  m: 0,
                  p: 0,
                },
                "& .MuiButton-root": {
                  p: 0,
                },
              }}
              onClick={handleFormSubmit}
            ></Button>
          </span>
        </Tooltip>
      )}
      {(isChatLoading || isGenerating) && (
        <Tooltip title="Stop" onClick={onStopChat}>
          <span style={{ marginLeft: "auto" }}>
            <IconButton
              color="error"
              data-testid={stopBtnTestId ?? "aa-input-stop-btn"}
              data-attr="assistant:btn:stop-generation"
            >
              <PulsatingStopCircle />
            </IconButton>
          </span>
        </Tooltip>
      )}
    </>
  );
};

export default ChatInputAdorements;
